import MasterRoleEditPage from './MasterRoleEditPage';

export default MasterRoleEditPage;
